// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');

// @constants
const cardImageIds= [
    'B.506.010.001',
    'B.506.010.004',
    'B.506.010.005',
];

class HirePackOpenYoungStep4 extends React.Component {
    render() {
        const { extraImage, immHireCardImageSelector, immHireCardImageIds } = this.props;
        return (
            <article className="hire-pack-open-young__step-four">
                <FormattedText
                    className="hire-pack-open-young__step-title"
                    value="hirePackOpenYoung-hirePackOpenYoung_step4Title"
                />
                <HireCardImageSelector
                    cardImageIds={immHireCardImageIds.toJS()}
                    extraClass="hire-pack-open-young__card-image-selector"
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                />
            </article>
        );
    }
}

HirePackOpenYoungStep4.propTypes = {
    extraImage: PropTypes.string,
    immHireCardImageSelector: PropTypes.object.isRequired,
};

module.exports = HirePackOpenYoungStep4;
